import { getQueryStringParameter } from '../../../helpers.js'

const disableInputs = () => {
  const $otherDocumentsFieldsOverMd = $('.over-md-size input');
  const $otherDocumentsFieldsUnderMd = $('.under-md-size input');

  if ($(window).width() < 768) {
    $($otherDocumentsFieldsUnderMd).prop('disabled', false);
    $($otherDocumentsFieldsOverMd).prop('disabled', true);
  } else {
    $($otherDocumentsFieldsOverMd).prop('disabled', false);
    $($otherDocumentsFieldsUnderMd).prop('disabled', true);
  }
};


$(document).ready(() => {
  const $form = $('form#legal-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'documents') {
    return;
  }

  disableInputs();

  // When clicking on the button to add a new other document
  $('.add_fields').on('click', function() {
    // Without the setTimeout it will call disableInputs before the new other document block is created
    setTimeout(disableInputs, 500);
  });

  $(window).on('resize', function() {
    disableInputs();
  });
})
